import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

var firebaseConfig = {
  apiKey: "AIzaSyAD54A1thsBzGPYP_ygagIvbK5wieTW2V4",
  authDomain: "ecom-admin-97da2.firebaseapp.com",
  projectId: "ecom-admin-97da2",
  storageBucket: "ecom-admin-97da2.firebasestorage.app",
  messagingSenderId: "835382602947",
  appId: "1:835382602947:web:6d03f1234f46d6d01d8676",
  measurementId: "G-2K20TKCDVY"
};


if(process.env.NODE_ENV === 'production'){
  firebaseConfig = {
    apiKey: "AIzaSyBgRzVyZxZ_W0uULiY58gtsAeSJMLHcMKc",
    authDomain: "ecomm-admin-f83b6.firebaseapp.com",
    projectId: "ecomm-admin-f83b6",
    storageBucket: "ecomm-admin-f83b6.firebasestorage.app",
    messagingSenderId: "715214245258",
    appId: "1:715214245258:web:bc398b3ce6f58900458c73",
    measurementId: "G-RTG6FZ5W8V"
  };
}



// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 